import React from 'react';
import { HStack } from '@adc/parallax-component-library';
import { TableFilters } from './TableFilters';
import { TableSelectionActions } from './TableSelectionActions';

interface TableToolbarProps {
  // Toolbar content props
  toolbarLeftContent?: React.ReactNode;
  toolbarRightContent?: React.ReactNode;
  // Filter props
  enableFiltering: boolean;
  checkboxFilters: any[];
  activeFiltersCount: number;
  onFilterChange: (sectionId: any, item: any) => void;
  onResetFilters: () => void;
  // Selection props
  enableSelection: boolean;
  isEveryVisibleRowSelected: boolean;
  onBatchSelectButtonPress: () => void;
  rowDataLength: number;
  selectionActions?: React.ReactNode;
  enableSelectAll?: boolean;
}

export const TableToolbar: React.FC<TableToolbarProps> = ({
  toolbarLeftContent,
  toolbarRightContent,
  enableFiltering,
  checkboxFilters,
  activeFiltersCount,
  onFilterChange,
  onResetFilters,
  enableSelection,
  isEveryVisibleRowSelected,
  onBatchSelectButtonPress,
  rowDataLength,
  selectionActions,
  enableSelectAll = true,
}) => {
  return (
    <HStack justifyContent="flex-end" alignItems="flex-end" gap="$2">
      {toolbarLeftContent}
      <HStack gap="$2" alignItems="flex-end">
        <TableFilters
          enableFiltering={enableFiltering}
          checkboxFilters={checkboxFilters}
          activeFiltersCount={activeFiltersCount}
          onFilterChange={onFilterChange}
          onResetFilters={onResetFilters}
        />
        <TableSelectionActions
          enableSelection={enableSelection && enableSelectAll}
          isEveryVisibleRowSelected={isEveryVisibleRowSelected}
          onBatchSelectButtonPress={onBatchSelectButtonPress}
          rowDataLength={rowDataLength}
          selectionActions={selectionActions}
        />
        {toolbarRightContent}
      </HStack>
    </HStack>
  );
};
